// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HfUb","col":"styles_col__5ApB6"};